














import { Component, VModel, Mixins } from 'vue-property-decorator';

import ModelSetter from "../../../../../Mixins/ModelSetter";
import ChipsInput from "../../../../../components/Pi/fields/ChipsInput/ChipsInput.vue";

@Component({
  components: {
    ChipsInput
  }
})
export default class ListSetup extends Mixins(ModelSetter) {
  @VModel() model!: Array<string>
}
